import { asScaled } from '../utils';
const numberInputerLayout = {
    buttonWidth: 20,
    buttonHeight: 20
};
const numberInputerLayoutScaled = asScaled(numberInputerLayout);
export const numberInputer = {
    scaled: numberInputerLayoutScaled,
    unscaled: numberInputerLayout
};
